export default __webpack_public_path__ + "static/media/SourceSans3-Bold.82c3c9be.ttf";